<div class="container">
	<table class="table">
		<thead>
		<tr>
			<th>Name</th>
			<th>Email</th>
			<th>MJ</th>
			<th>Admin</th>
			<th>Actions</th>
		</tr>
		</thead>
		<tbody>
			@for (user of users; track user) {
				<tr>
					<td>{{ user.name }}</td>
					<td><a [href]="'mailto:' + user.mail">{{ user.mail }}</a></td>
					<td>
						@if (!user.isSuperAdmin) {
							<button
								type="button"
								class="btn btn-sm"
								[class.btn-success]="!user.isMJ"
								[class.btn-outline-danger]="user.isMJ"
								(click)="toggleMj(user)"
							>
								{{ user.isMJ ? 'Rétrograder MJ' : 'Promouvoir MJ' }}
							</button>
						} @else {
							<span class="badge text-bg-secondary">Super admin</span>
						}
					</td>

					<td>
						@if (!user.isSuperAdmin) {
							<button
								type="button"
								class="btn btn-sm"
								[class.btn-success]="!user.isAdmin"
								[class.btn-outline-danger]="user.isAdmin"
								(click)="toggleAdminRole(user)"
							>
								{{ user.isAdmin ? 'Rétrograder Admin' : 'Promouvoir Admin' }}
							</button>
						} @else {
							<span class="badge text-bg-secondary">Super admin</span>
						}
					</td>

					<td>
						@if (!user.isSuperAdmin) {
							<button
								type="button"
								class="btn btn-sm btn-warning"
								(click)="suspendUser(user)"
							>
								Suspendre
							</button>
						} @else {
							<span class="text-muted">—</span>
						}
					</td>
				</tr>
			}
		</tbody>
	</table>
</div>
